import { Box, Button, FormControl, FormHelperText, Grid, Paper, TextField, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useAddMenuFilhoMutation, useGetMenuFilhoQuery } from './menuFilhoApiSlice';
import { ISmenuFilho, MenuFilho, MenuFilhoDTO } from '../../../../../typesSite/menuFilho/MenuFilho';
import errorFormat from '../../../../../utils/errorFormat';
import TxtMenuPaiSite from '../../../../autoComplete/TxtMenuPaiSite';
import { ISmenuPai, MenuPai, MenuPaiList } from '../../../../../typesSite/menuPai/MenuPai';
import TxtNoticiaSite from '../../../../autoComplete/TxtNoticiaSite';
import { Noticia } from '../../../../../typesSite/noticia/Noticia';

export const MenuFilhoCreate = () => {
  const [menuFilho, SetMenuFilho] = useState<MenuFilho>(ISmenuFilho);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [createMenuFilho, status] = useAddMenuFilhoMutation();
  const navigate = useNavigate();

  //verificar se for edicao ele pega o id e faz a consulta
  const id = useParams().id || '';
  const { data, isFetching, error } = useGetMenuFilhoQuery(id);
  useEffect(() => {
    if (data) {
      SetMenuFilho(data);
    }
  }, [data, error, isFetching]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const cursorPosition = e.target.selectionStart;

    SetMenuFilho(prev => ({
      ...prev,
      [name]: value
    }));

    // Aguarde até que o DOM seja atualizado
    setTimeout(() => {
      const input = e.target;
      input.setSelectionRange(cursorPosition, cursorPosition);
    }, 0);
  };

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (!menuFilho.menuPai || !menuFilho.menuPai.id) {
      enqueueSnackbar('O Menu Pai deve ser informado!', { variant: 'warning' });
      return;
    }

    const parms: MenuFilhoDTO = {
      id: menuFilho.id,
      label: menuFilho.label,
      link: menuFilho.link,
      idPai: menuFilho.menuPai?.id || '',
      idNoticia: menuFilho.noticia?.id || '',
      ordem: menuFilho.ordem || 0,
      isEscolaLegislativo: menuFilho.menuPai?.isEscolaLegislativo || false
    };
    await createMenuFilho(parms);
  }

  useEffect(() => {
    if (status.isError) {
      enqueueSnackbar('Registro não incluído!', { variant: 'error' });
      const erroReturn: string = errorFormat(status);
      enqueueSnackbar(erroReturn, { variant: 'error' });
    }

    if (status.isSuccess) {
      enqueueSnackbar('Registro incluído!', { variant: 'success' });
      navigate(-1);
      // setGrupo(ISgrupo);
    }
  }, [status]);

  const [menuPaiSelecionado, setMenuPaiSelecionado] = useState<MenuPai>(ISmenuPai);

  const handletxtMenuPaiChange = (menuPai: MenuPai) => {
    setMenuPaiSelecionado(menuPai as MenuPai);
    SetMenuFilho(prev => ({
      ...prev,
      menuPai: menuPai as MenuPaiList
    }));
  };

  return (
    <>
      <Paper
        elevation={3}
        sx={{
          width: {
            xs: '100%', // 100% em telas pequenas
            sm: '90%', // 90% em telas médias ou maiores
            md: '90%',
            lg: '90%'
          },
          maxWidth: '1200px', // Limite opcional
          p: 2
        }}
      >
        <Typography variant="h6" component="h1" sx={{ padding: 2 }}></Typography>

        <Typography variant="h6" component="h1" sx={{ mb: 2 }}>
          {menuFilho.id ? 'Edição' : 'Inclusão'} Sub Menu nível 2
        </Typography>

        <form onSubmit={handleSubmit} method="POST">
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Box display="flex" justifyContent="space-between" gap={2}>
                <FormControl fullWidth>
                  <TxtMenuPaiSite
                    isdisabled={false}
                    value={menuFilho.menuPai}
                    handleSearchChange={it => {
                      handletxtMenuPaiChange(it);
                    }}
                  />
                </FormControl>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth>
                <TextField
                  required
                  label="Titulo do Menu"
                  name="label"
                  onChange={handleChange}
                  size="small"
                  inputProps={{ maxLength: 30 }}
                  value={menuFilho.label}
                  //multiline // Adiciona o suporte a múltiplas linhas
                  //rows={4}
                />
                <FormHelperText>{menuFilho.label?.length}/30 caracteres</FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth>
                <TextField label="Link para o Menu" name="link" onChange={handleChange} size="small" inputProps={{ maxLength: 255 }} value={menuFilho.link} />
                <FormHelperText>{menuFilho.link?.length}/255 caracteres</FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <Box display="flex" justifyContent="space-between" gap={2}>
                <FormControl fullWidth>
                  <TxtNoticiaSite
                    isdisabled={false}
                    value={menuFilho.noticia as Noticia}
                    handleSearchChange={it => {
                      SetMenuFilho(prev => ({
                        ...prev,
                        noticia: it as Noticia
                      }));
                    }}
                  />
                </FormControl>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth>
                <TextField
                  label="Ordem do Link no Menu"
                  name="ordem"
                  onChange={handleChange}
                  size="small"
                  inputProps={{
                    maxLength: 3,
                    inputMode: 'numeric', // para dispositivos móveis
                    pattern: '[0-9]*' // restringe a números
                  }}
                  value={menuFilho.ordem || ''}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <Box display="flex" gap={2}>
                <Button type="submit" variant="contained" color="secondary">
                  Gravar
                </Button>

                <Button variant="contained" onClick={() => navigate(-1)}>
                  Voltar
                </Button>
              </Box>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </>
  );
};
